module.exports = __webpack_public_path__ + "img/public/SiteIcons/fileIcon.svg?1140aacf";